import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseRegisterHeader.module.scss'

import IconPrev20x20 from '@Ui/images/myhouse/IconPrev20x20.svg'
import IconClose16x16 from '@Ui/images/myhouse/IconClose16x16.svg'

const cx = className.bind(style)

type Props = {
  onPrevClick?: any
  onCloseClick?: any
}

const MyhouseRegisterHeader: React.FC<Props> = ({ onPrevClick, onCloseClick }: Props) => {
  return (
    <header className={cx('header_myhouse', 'type_detail')}>
      <div className={cx('header_myhouse_inner')}>
        {onPrevClick && (
          <a href="#" onClick={onPrevClick} className={cx('myhouse_header_link', 'type_prev')} aria-label="뒤로 가기">
            <IconPrev20x20 />
          </a>
        )}
        {onCloseClick && (
          <a href="#" onClick={onCloseClick} className={cx('myhouse_header_link', 'type_close')} aria-label="닫기">
            <IconClose16x16 />
          </a>
        )}
      </div>
    </header>
  )
}

export default MyhouseRegisterHeader
